import { render, staticRenderFns } from "./RecipeInvoice.vue?vue&type=template&id=54d5297d&scoped=true"
import script from "./RecipeInvoice.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecipeInvoice.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RecipeInvoice.vue?vue&type=style&index=0&id=54d5297d&prod&scoped=true&lang=css"
import style1 from "./RecipeInvoice.vue?vue&type=style&index=1&id=54d5297d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d5297d",
  null
  
)

export default component.exports